import React from 'react';
import ReactDOM from 'react-dom/client';
import clarity from '@microsoft/clarity';
import { HelmetProvider } from 'react-helmet-async';
import './fonts.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const isProduction = process.env.NODE_ENV === 'production';
if (isProduction) {
  clarity.init('wgn0hu01hc');
}

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Production HTML is pre-rendered at build time (scripts/prerender.js), so hydrate
// the existing markup; in development the container is empty and we render fresh.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
